import React from 'react'
import Link from '@salesforce/retail-react-app/app/components/link'
import {useIntl, defineMessages, FormattedMessage} from 'react-intl'
import {useBrand} from '../../contexts/brand-context'

const messages = defineMessages({
    notifyMeEmail: {defaultMessage: 'Email Address', id: 'pdp_notify_me_email.label'},
    notifyMeCheckbox: {
        defaultMessage: 'Yes, I would like to be notified about this product, and to receive updates from {brand} with the latest deals, sales and updates. I agree to the {terms} and {privacy}.',
        id: 'pdp_notify_me_checkbox.text.label'
    },
    termsAndConditions: {
        defaultMessage: 'Terms and Conditions',
        id: 'terms_and_conditions_link.label'
    },
    privacyPolicy: {
        defaultMessage: 'Privacy Policy',
        id: 'privacy_policy_link.label'
    }
})

export default function useWriteReviewFields({
    form: {
        control,
        formState: { errors = {} } = {}
    } = {},
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const {brandId} = useBrand()
    const brandName = brandId ? brandId.charAt(0).toUpperCase() + brandId.slice(1) : 'Dynamite'
    const fields = {
        "notifyMeEmail": {
            name: `${prefix}notifyMeEmail`,
            label: formatMessage(messages.notifyMeEmail),
            defaultValue: '',
            type: 'email',
            variant: 'webFloatingField',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please fill out this field',
                    id: 'required_field.label'
                }),
                maxLength: {
                    value: 50,
                    message: formatMessage({
                        defaultMessage: 'Maximum of 50 characters.',
                        id: 'max_50_chars.label'
                    })
                },
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: formatMessage({
                        defaultMessage: 'Invalid email address.',
                        id: 'format_email_field.label'
                    })
                }
            },
            error: errors[`${prefix}notifyMeEmail`],
            control
        },
        "notifyMeTermsAndConditions": {
            name: `${prefix}notifyMeTermsAndConditions`,
            label: (
                <FormattedMessage
                    {...messages.notifyMeCheckbox}
                    values={{
                        brand: brandName,
                        terms: (
                            <Link
                                variant={'link'}
                                style={{textDecoration: 'underline', fontSize: '12px'}}
                                to="/terms-conditions.html"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <FormattedMessage {...messages.termsAndConditions} />
                            </Link>
                        ),
                        privacy: (
                            <Link
                                variant={'link'}
                                style={{textDecoration: 'underline', fontSize: '12px'}}
                                to="/privacy-policy.html"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <FormattedMessage {...messages.privacyPolicy} />
                            </Link>
                        )
                    }}
                />
            ),
            control,
            defaultValue: false,
            type: 'checkbox',
        },
        "notifyMeSKU": {
            name: `${prefix}notifyMeSKU`,
            control,
            defaultValue: '',
            type: 'hidden',
        }
    }

    return fields
}
